<template>
  <div class="login-page">
    <el-button type="primary"  tag="a" size="large" :href="`${API_URL}/builder/users/login`">
      Войти через SSO
    </el-button>
  </div>
</template>

<script lang="ts" setup>
import {API_URL} from "@/resourses/api";
</script>

<style lang="scss">
@use "@/styles/assembly" as *;
@use "@/styles/variables" as *;
.login-page{
  display: flex;
  justify-content: center;
  height: 100%;
  align-items: center;
}

</style>
